export default __webpack_public_path__ + "static/media/kushki.87af6de2.png";